<template>
  <CustomModal ref="modal" class="add-business-modal" title="Créer un devis">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="element">
            <CustomSelectField :content=inputs.client />
            <div v-if="clientOrders.length > 0" class="order-proposal">
              <p v-if="selectedOrder">
                Ce devis sera associé au dossier <b>n°{{ selectedOrder.number }}</b><span v-if="selectedOrder.title" class="order-title" :title="selectedOrder.title">« {{ selectedOrder.title }} »</span>.
                <a v-if="clientOrders.length > 1" @click="openSelectOrderModal">Changer de dossier</a>
                <a @click="selectedOrderNumber = undefined">Ne pas l'associer</a>
              </p>
              <p v-else-if="clientOrders.length === 1">
                Ce client a un dossier en cours : <b>n°{{ clientOrders[0].number }}</b><span v-if="clientOrders[0].title" class="order-title" :title="clientOrders[0].title">« {{ clientOrders[0].title }} »</span>.
                Voulez-vous y associer ce devis ?
                <a @click="selectedOrderNumber = clientOrders[0].number">Associer à ce dossier</a>
              </p>
              <p v-else>
                Ce client a {{ clientOrders.length }} dossiers en cours. Voulez-vous associer ce devis à l'un d'eux ?
                <a @click="openSelectOrderModal">Choisir un dossier</a>
              </p>
            </div>
            <div class="title-number-container">
              <CustomTextField class="title" :content=inputs.title />
              <CustomTextField class="number" :content=inputs.number />
            </div>
          </div>
        </div>
        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px"/>
      </CustomForm>
    </div>
    <SelectClientOrderModal ref="selectOrderModal" :callback=chooseOrderCallback />
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faPlus, faUpLong, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
import {ClientController} from "@/controllers/business/ClientController";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import SelectClientOrderModal from "@/components/modals/SelectClientOrderModal.vue";
library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

  export default {
      name: 'AddBusinessModal',
      props: ['callback'],
      components: {CustomModal, CustomForm, CustomSelectField, CustomTextField, CustomButton, SelectClientOrderModal},
      data() {
          return {
            documentName: "test",
            inputs: {
              title: {label: 'Titre', value: '', type: 'text', required: true},
              number: {label: 'N°', value: '', type: 'number', placeholder: 'Auto'},
              client: {label: 'Client', value: '', type: 'select', selectValues: [{label:"TODO", value: "TODO"}], required: true},
            },
            buttons:{
              submit: {text: "Suivant"}
            },
            isTerminateButtonDisplayed: false,
            // Dossiers en cours du client choisi (option production) et dossier auquel le devis sera rattaché dès sa création
            clientOrders: [],
            selectedOrderNumber: undefined
          };
      },
      computed: {
        selectedOrder() {
          return this.clientOrders.find(order => order.number === this.selectedOrderNumber);
        }
      },
      watch: {
        'inputs.client.value'(clientId) {
          this.loadClientOrders(clientId);
        }
      },
      methods: {
        async openModal() {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.buttons.submit.disabled = false;
          this.inputs.title.value = '';
          this.inputs.number.value = 0;
          this.inputs.number.value = '';
          this.inputs.client.value = '';
          this.clientOrders = [];
          this.selectedOrderNumber = undefined;
          await this.fillClientSelect();
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(businessId){
          this.closeModal();
          this.callback(businessId);
        },
        async fillClientSelect(){
          // Get the table data
          this.inputs.client.selectValues = [];
          const resp = await ClientController.getAll();
          if(!resp.errors){
            resp.sort((a, b) => a.structuredInformations.name.localeCompare(b.structuredInformations.name));
            for(let i=0; i < resp.length ;i++){
              this.inputs.client.selectValues.push({label:resp[i].structuredInformations.name, value: resp[i].id});
            }
          }
        },
        haveProductionOption() {
          return localStorage && localStorage.options && localStorage.options.includes('production');
        },
        // Un client qui a déjà un dossier en cours : on propose (facultatif) d'y associer le devis, rien n'est associé tant que l'utilisateur ne l'a pas demandé
        async loadClientOrders(clientId) {
          this.clientOrders = [];
          this.selectedOrderNumber = undefined;
          if (!clientId || !this.haveProductionOption()) return;

          const orders = await BusinessController.getClientOrders(clientId);
          // Le client a pu changer pendant la requête
          if (this.inputs.client.value !== clientId || !orders || orders.errors) return;

          this.clientOrders = orders;
        },
        openSelectOrderModal() {
          this.$refs.selectOrderModal.openModal(this.clientOrders, this.selectedOrderNumber);
        },
        chooseOrderCallback(orderNumber) {
          this.selectedOrderNumber = orderNumber;
          // La fermeture de la modale de choix a réactivé le défilement de la page : cette modale-ci est toujours ouverte
          document.body.style.overflow = "hidden";
        },
        async submitForm() {
          const body = {
            clientId : this.inputs.client.value,
            number : this.inputs.number.value,
            title : this.inputs.title.value
          };
          if (this.selectedOrderNumber !== undefined) {
            body.orderNumber = this.selectedOrderNumber;
          }
          const res = await this.$refs.form.submitForm(() => BusinessController.post(body));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Contrat ajouté");
            this.terminate(res);
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .form-container
      display flex
      flex-direction column

    .submit-button
      margin 20px auto auto

    // Proposition de rattachement à un dossier existant : information neutre, donc en bleu
    .order-proposal
      margin-top 10px
      padding 8px 12px
      border-left 3px solid CTRL_FOCUS
      border-radius CTRL_RADIUS_SM
      background #eef2fb
      p
        margin 0
        font-size 13px
        line-height 1.5
        color FONT_COLOR
      a
        margin-left 6px
        font-weight 600
        color CTRL_FOCUS
        cursor pointer
        text-decoration underline
      .order-title
        display inline-block
        max-width 200px
        margin-left 4px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        vertical-align bottom

    @media only screen and (min-width: DESKTOP_SIZE)
      .form-container
        flex-direction row
        .element
          width: calc(100% - 4em)
          padding 2em

      .submit-button
        width 250px

    .title-number-container
      display flex
      .title
        margin-right 1em
      .number
        width 100px !important
</style>

<style lang="stylus">
  .add-business-modal .modal
    width 500px !important
</style>